import React from 'react';
import { faHistory } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './RescheduledButton.module.css';
import { CommonButton } from '_components';


export class RescheduledButton extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className ) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : ''} onClick={this.props.onClick} size={this.props.size} className={cls} >
                <FontAwesomeIcon icon={faHistory} transform="shrink-6 flip-h" color="#717271" />
            </CommonButton>
        );
    }
}
